import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.small";
import React from 'react';
import hash from 'string-hash';
/**
 * Stateless component for rendering a text-like form element. (Type of “text”,
 * “tel”, “password”, &c.)
 *
 * If necessary, an element can be passed in as the “label” property instead
 * of text. Its child elements should only contain plain text. The most common
 * case would be several sibling <span>s:
 *
 * label={
 *  <>
 *    <span style={{ whiteSpace: 'nowrap' }}>Label will be very long</span>
 *    <wbr />
 *    <span style={{ whiteSpace: 'nowrap' }}>
 *      and we want some control over how the browser will break the text
 *    </span>
 *  </>
 *  }
 *
 * Automatically generates an id for the element if one is not provided. Will
 * also add the “txt-f” class to the element, and the “txt-f--err” class if
 * there’s an error.
 *
 * If “hideLabel” is specified, the label text must be a string; it will be
 * added as an aria-label attribute on the <input> element.
 */

export default function TextInput(props) {
  var id = props.id || "input-".concat(hash(props.label));
  var classNames = {
    label: "txt-l ".concat(props.small ? 'txt-l--sm' : ''),
    input: "txt-f ".concat(props.small ? 'txt-f--sm' : '', " ").concat(props.error ? 'txt-f--err' : '')
  };

  var labelText = function labelText(label) {
    if (typeof label === 'string') {
      var styleObj = {
        marginRight: '0.5em'
      };

      if (!props.disableLabelNoWrap) {
        styleObj['whiteSpace'] = 'nowrap';
      }

      return React.createElement("span", {
        style: styleObj
      }, label);
    } else {
      return label;
    }
  };

  var optionalDescriptionElem = function optionalDescriptionElem(optionalDescription) {
    var cont = 'notice css-content-psedo';
    return React.createElement("label", {
      className: cont
    }, optionalDescription);
  };

  var labelElem = function labelElem() {
    var modLabelStyle = {
      marginTop: '1em',
      marginBottom: '2em'
    };
    var optStyles = props.labelBelowInput ? modLabelStyle : {};
    return React.createElement("label", {
      htmlFor: id,
      className: classNames.label,
      style: optStyles
    }, props.hideLabel ? React.createElement(React.Fragment, null, "\xA0") : labelText(props.label), props.required && React.createElement("span", {
      className: "t--req",
      "aria-hidden": "true"
    }, "Required"));
  };

  var spacer = function spacer() {
    return React.createElement("div", {
      className: "t--subinfo t--err m-b100 m-t100"
    }, props.error && typeof props.error === 'string' ? props.error : React.createElement(React.Fragment, null, "\xA0"));
  };

  return React.createElement("div", {
    className: props.className,
    style: props.style
  }, !props.labelBelowInput && labelElem(), props.labelBelowInput && spacer(), typeof props.optionalDescription !== 'undefined' && optionalDescriptionElem(props.optionalDescription), React.createElement("input", {
    className: classNames.input,
    id: id,
    "aria-label": props.hideLabel ? props.label : '',
    type: props.type || 'text',
    name: props.name,
    placeholder: props.placeholder,
    value: props.value,
    defaultValue: props.defaultValue,
    disabled: props.disabled,
    required: props.required,
    inputMode: props.inputMode,
    maxLength: props.maxLength,
    minLength: props.minLength,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onKeyDown: props.onKeyDown
  }), props.labelBelowInput && labelElem(), !props.labelBelowInput && spacer());
}